import styles from "./Designer.module.css";

const ConfirmSideModal = ({ sideConfirm, applySelectPrint, setSideConfirm, setViewSide }) => {
    if (!sideConfirm) return null;

    const handleKeep = () => {
        applySelectPrint(sideConfirm.partKey, sideConfirm.locationKey, sideConfirm.print, sideConfirm.defaultSide);
        setSideConfirm(null);
    };

    const handleMove = () => {
        const forcedSide = sideConfirm.suggested === "back" ? 1 : 0;
        applySelectPrint(sideConfirm.partKey, sideConfirm.locationKey, sideConfirm.print, forcedSide);
        setViewSide(forcedSide === 1 ? "back" : "front");
        setSideConfirm(null);
    };

    return (
        <div className={styles.confirmOverlay} onClick={(e) => e.stopPropagation()}>
            <div className={styles.confirmCard} onClick={(e) => e.stopPropagation()}>
                <h4 className={styles.confirmTitle}>
                    {sideConfirm.suggested === "back" ? "Colocar en Espalda" : "Colocar en Frente"}
                </h4>
                <p className={styles.confirmText}>
                    Este diseño parece ser de {sideConfirm.suggested === "back" ? "ESPALDA" : "FRENTE"}. ¿Dónde querés colocarlo?
                </p>
                <div className={styles.confirmButtons}>
                    <button className={`${styles.btn} ${styles.confirmBtnOutline}`} onClick={handleKeep}>
                        Dejar en {sideConfirm.defaultSide === 1 ? "Espalda" : "Frente"}
                    </button>
                    <button className={styles.btn} onClick={handleMove}>
                        Mover a {sideConfirm.suggested === "back" ? "Espalda" : "Frente"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmSideModal;
